module.exports = __webpack_public_path__ + "img/iris.f3c397af.jpg";